@if ((runningInPortal$ | async) === false) {
  <mat-toolbar>
    <span class="standalone-toolbar-spacer"></span>
    <button mat-icon-button tabindex="-1" (click)="doLogout()">
      <mat-icon>logout</mat-icon>
    </button>
  </mat-toolbar>
}

<div class="content-outlet">
  <router-outlet></router-outlet>
</div>

<footer>
  @if (showImpressumButton) {
    <p class="impressum"
       [routerLink]="'/legal/impressum'"
       (click)="trackMatomoEvent('Link zum Impressum', 'Klick auf Impressum / Datenschutz')">
      Impressum / Datenschutz
    </p>
  }

  @if (showThirdPartyContentDisclaimer) {
    <p class="disclaimer"
       [routerLink]="'/legal/disclaimer'"
       (click)="trackMatomoEvent('Link zum Haftungsausschluss', 'Klick auf Haftungsausschluss')">
      Haftungsausschluss
    </p>
  }
</footer>
